import React from 'react'
import { Input } from 'antd'
import { Search } from 'lucide-react'

interface Props {
  accessories: boolean
  value: string
  onChange: (value: string) => void
}

export const MaterialSearch: React.FC<Props> = ({ value, onChange, accessories }) => {
  return (
    <Input
      prefix={<Search className="h-4 w-4 text-gray-400" />}
      placeholder={`Search ${accessories ? 'accessories' : 'materials'} by name or type...`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="mb-4"
    />
  )
}
